// COMPONENT
const Ambulance = () => (
  <div>
    <h1 className="flex flex-col text-center">অ্যাম্বুলেন্স সেবা</h1>
    <p>This page is under construction</p>
    <div className="flex flex-col p-3 shadow">
      <p>নামঃ&nbsp;কিছু একটা নাম</p>
      <h5>যোগাযোগঃ&nbsp;০১৭........</h5>
    </div>
  </div>
);

// EXPORT
export default Ambulance;
